module.exports = __webpack_public_path__ + "img/casey-sensei.f916637e.jpg";